<template>
  <GuDropdownMenu>
    <GuDropdownMenuTrigger as-child>
      <GuButton variant="light" size="sm" :aria-label="`View selection actions for datagrid`">
        Select
      </GuButton>
    </GuDropdownMenuTrigger>

    <GuDropdownMenuContent>
      <GuDropdownMenuItem @select="selectCurrentPage">
        Select Current Page
      </GuDropdownMenuItem>

      <!-- This is disabled for now, we need to check a way to get all data from server-side
      grids and map all selected items, as server-side grids don't have the items in the
      prev/next pages loaded. We'd need a server api call with the row limit equals to
      the total of items, which is quite a heavy API call -->
      <!-- <GuDropdownMenuItem v-if="totalRowCount <= 500" @select="selectAll">
        Select All ({{ totalRowCount }})
      </GuDropdownMenuItem> -->

      <GuDropdownMenuItem class="text-danger" @select="deselectAll">
        Deselect All
      </GuDropdownMenuItem>
    </GuDropdownMenuContent>
  </GuDropdownMenu>
</template>

<script setup>
import { inject, ref } from 'vue'

import { GuButton } from '@shared/gu-components/button'
import {
  GuDropdownMenu,
  GuDropdownMenuContent,
  GuDropdownMenuItem,
  GuDropdownMenuTrigger,
} from '@shared/gu-components/dropdown-menu'

const props = defineProps({
  gridApi: {
    type: Object,
    required: true,
  },
})

// eslint-disable-next-line no-unused-vars
const gridState = inject('gridState')
const gridApi = ref(props.gridApi)

// const currentPageCount = computed(() => {
//   if (!gridApi.value) return 0

//   return gridApi.value.paginationGetPageSize()
// })

// const totalRowCount = computed(() => {
//   if (!gridApi.value) return 0
//   return gridApi.value.paginationGetRowCount()
// })

const selectCurrentPage = () => {
  if (!gridApi.value) return

  const nodes = []
  gridApi.value.forEachNode((node) => {
    nodes.push(node)
  })

  nodes.forEach((node) => {
    node.setSelected(true)
  })

  gridApi.value.setServerSideSelectionState({
    selectAll: false,
    toggledNodes: nodes.map((node) => node.id),
  })
}

// Disabled until we have a better solution for the server-side grid
// const selectAll = () => {
//   if (!gridApi.value) return

//   const currentPage = gridApi.value.paginationGetCurrentPage()

//   gridApi.value.setServerSideSelectionState({
//     selectAll: true,
//     toggledNodes: [],
//   })

//   gridApi.value.paginationGoToPage(currentPage)
// }

const deselectAll = () => {
  if (!gridApi.value) return

  const currentPage = gridApi.value.paginationGetCurrentPage()

  gridApi.value.setServerSideSelectionState({
    selectAll: false,
    toggledNodes: [],
  })

  gridApi.value.paginationGoToPage(currentPage)
}
</script>

<style scoped>
.bulk-selector {
  margin-bottom: 1rem
}
</style>
